const primaryCyan = '#2fc5d2'
const primaryGold = '#efbe41'

export const chart = {
  vami: primaryCyan,
  sAndP: primaryGold,
  benchmark: '#b1347d',
}
